// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import Accordion from 'client/components/accordion/accordion';
import CONTENTFUL_ENTRY_ID from 'client/constants/contentfulEntry';
import HeroContainer from 'client/components/heroContainer';
import Panel from 'client/components/accordion/panel';
import {
  COVID19_FIND_WORK_TAB_CLICK,
  COVID19_FIND_WORK_TYPE_SELECT,
} from 'client/constants/amplitudeTracker';
import { Tracking } from 'web-core/src/tracking';
import { trackAccordionClick } from './utils/tracking';
import ContentFilter, { type ContentItemType } from './shared/contentFilter';
import IntroSection, { type IntroType } from './shared/introSection';
import ResourcesNav, { type NavType } from './shared/resourcesNav';

import '../styles/guidePage.scss';
import '../styles/findWork.scss';

type AccordionContentType = {
  accordionHeader: string,
  accordionItems: Array<{
    title: string,
    content: string,
  }>,
};

type Props = {
  fetchContentful: Function,
  contentfulData: {
    contentFilter: {
      description: string,
      header: string,
    },
    delivery: AccordionContentType,
    grocery: AccordionContentType,
    hero: Object,
    intro: IntroType,
    nav: NavType,
    taskBased: AccordionContentType,
    teacherAndTutors: AccordionContentType,
    writers: AccordionContentType,
  },
};

const jobTypeFilterOptions = [
  {
    value: 'delivery',
    label: 'Delivery',
  },
  {
    value: 'grocery',
    label: 'Grocery',
  },
  {
    value: 'taskBased',
    label: 'Online task-based work',
  },
  {
    value: 'teacherAndTutors',
    label: 'Online jobs for teachers and tutors',
  },
  {
    value: 'writers',
    label: 'Online jobs for writers',
  },
];

const FILTER_PLACEHOLDER = 'Filter by job type';

class FindWorkPage extends Component<Props> {
  componentDidMount() {
    this.props.fetchContentful(CONTENTFUL_ENTRY_ID.COVID_19_FIND_WORK);
  }

  trackTypeSelect = (type: string) => {
    Tracking.track(COVID19_FIND_WORK_TYPE_SELECT, { type });
  };

  renderJobCategoryAccordion = (): Array<ContentItemType> =>
    _.map(jobTypeFilterOptions, (option) => {
      const accordionData = _.get(this.props, `contentfulData[${option.value}]`, {});
      const { accordionItems, accordionHeader } = accordionData;

      return {
        category: option.value,
        content: (
          <React.Fragment>
            {accordionHeader && <div className="header pad-bottom">{accordionHeader}</div>}
            <Accordion
              key={accordionHeader}
              onChange={state => trackAccordionClick(COVID19_FIND_WORK_TAB_CLICK, state)}>
              {!_.isEmpty(accordionItems) &&
                _.map(accordionItems, item => (
                  <Panel key={item.title} title={<span>{item.title}</span>}>
                    <div dangerouslySetInnerHTML={{ __html: `${item.content}` }} />
                  </Panel>
                ))}
            </Accordion>
          </React.Fragment>
        ),
      };
    });

  render() {
    const {
      contentfulData: { contentFilter, hero, intro, nav },
    } = this.props;

    const contentFilterProps = {
      changeHandler: this.trackTypeSelect,
      defaultShowAll: true,
      defaultValue: '',
      description: _.get(contentFilter, 'description', ''),
      filterByKey: 'category',
      header: _.get(contentFilter, 'header', ''),
      input: {
        type: 'Select',
        inputGroupProps: {
          options: jobTypeFilterOptions,
          label: null,
          placeholder: FILTER_PLACEHOLDER,
        },
      },
      items: this.renderJobCategoryAccordion(),
    };

    return (
      <div className="find-work-page guide-page-container">
        <HeroContainer base="finance-guide" {...hero} />
        <div className="content-container">
          {intro && <IntroSection intro={intro} />}
          <ContentFilter {...contentFilterProps} />
          {nav && <ResourcesNav nav={nav} />}
        </div>
      </div>
    );
  }
}

export default FindWorkPage;
